<template>
  <div>
    <topback title="Pin" path="back"></topback>
    <div class="pin">
      PIN
    </div>

    <div class="font">
      Please set a secure password. If you have already completed the setup, you
      do not need to set it up again.
    </div>

    <div style="padding-top: 0.4rem;margin: 0rem 0.3rem;">
      <p class="font1">Please enter Pin</p>
      <md-codebox :mask="true" :maxlength="6" v-model="code1" :justify="true" />
    </div>

    <div style="padding-top: 0.4rem;margin: 0rem 0.3rem;">
      <p class="font1">Please confirm Pin</p>
      <md-codebox :mask="true" :maxlength="6" v-model="code2" :justify="true" />
    </div>

    <div style="margin: 0.5rem;">
      <md-input-item
        type="digit"
        v-model="OTP"
        placeholder="Enter the mobile phone OTP"
        :brief="'You phone '+enphone"
        is-highlight
        maxlength="6"
      >
        <div
          class="input-operator"
          slot="right"
          @click="onSend"
          :style="{ backgroundColor: buttonColor, cursor: buttonCursor }"
        >
          {{ semdtext }}
        </div>
      </md-input-item>
    </div>

    <div style="margin: 0.8rem;">
      <md-button type="primary" :size="small" round @click="sub"
        >Confirm</md-button
      >
    </div>
    <div v-if="cf_turnstile_sitekey" style="display: none;">
      <vue-turnstile
        :site-key="cf_turnstile_sitekey"
        @verified="token = $event"
      />
    </div>
    <Loading :isloading="isLoading"></Loading>
  </div>
</template>

<script>
import topback from "@/components/topback";
import { Toast, Codebox, Button, InputItem } from "mand-mobile";
import { safety, sendsms, getsiteconfig, cftoken } from "@/request/api";
import VueTurnstile from "@gaviti/vue-turnstile";
import Loading from "@/components/Loadingsaly.vue";

export default {
  name: "deposithistory",
  components: {
    [topback.name]: topback,
    [InputItem.name]: InputItem,
    [Button.name]: Button,
    [Codebox.name]: Codebox,
    VueTurnstile,
    Loading
  },

  data() {
    return {
      phone: "",
      code1: "",
      countdown: 0,
      OTP: "",
      semdtext: "Send OTP",
      buttonColor: "#198cff",
      code2: "",
      enphone: "",
      token: "",
      isLoading: true,
      sendtoken: "",
      cf_turnstile_sitekey: ""
    };
  },
  created() {
    this.phone = localStorage.getItem("phone") || "";
    const storedPhone = localStorage.getItem("phone") || "";

    this.enphone = this.maskPhoneNumber(storedPhone);
    this.cf_turnstile_sitekey = localStorage.getItem("cf_key") || "";

    if (!localStorage.getItem("cf_key")) {
      getsiteconfig().then(res => {
        if (res.code === 200) {
          this.cf_turnstile_sitekey = res.data.cf_turnstile_sitekey;
          localStorage.setItem("cf_key", res.data.cf_turnstile_sitekey);
        }
      });
    }

    setTimeout(() => {
      if (!this.token) {
        window.location.reload();
      }
    }, 7000);

    this.$watch("token", (newValue, oldValue) => {
      if (newValue) {
        this.isLoading = false; // 如果 token 有值，则关闭加载动画
      } else {
        this.isLoading = true; // 如果 token 为空，则显示加载动画
      }
    });
  },
  methods: {
    maskPhoneNumber(phone) {
      if (phone.length >= 6) {
        const maskedPart =  "******" + phone.substring(6, 10)
        return maskedPart;
      } else {
        return phone;
      }
    },

    sub() {
      if (!this.OTP) {
        Toast.failed("Please enter OTP");
        return;
      }

      if (this.code1 !== "" && this.code2 !== "" && this.code1 === this.code2) {
        safety({
          phone: this.phone,
          safety_code: this.code2,
          sendtoken: this.sendtoken,
          smscode: this.OTP
        })
          .then(res => {
            if (res.code == 200) {
              Toast.succeed("Setup successful");
              this.$router.push("my");
            } else {
              Toast.failed(res.errmsg);
            }
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        Toast.failed("Please enter correct information");
      }
    },

    onSend() {
      if (!this.token) {
        Toast.failed("Unsafe environment");
        return;
      }

      if (this.countdown > 10) {
        Toast.failed("Frequent operations");
        return;
      }

      if (this.code1 !== "" && this.code2 !== "" && this.code1 === this.code2) {
        cftoken({ token: this.token }).then(res => {
          if (res.code == 200) {
            this.sendtoken = res.data.sendtoken;
            sendsms({
              phone: this.phone,
              sendtoken: this.sendtoken,
              purpose: "securitypassword"
            })
              .then(res => {
                if (res.code == 200) {
                  Toast.succeed("Sent successfully");
                  this.countdown = 120;
                  this.startCountdown();
                }
              })
              .catch(error => {
                console.log(error);
              });
          }
        });
      } else {
        Toast.failed("Please enter correct information");
      }
    },

    startCountdown() {
      const timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
          this.semdtext = `${this.countdown}s`; // 设置按钮文本
          this.buttonColor = "#a9a9a9"; // 设置按钮颜色
          this.buttonCursor = "not-allowed";
        } else {
          clearInterval(timer); // 清除计时器
          this.semdtext = "Send OTP"; // 恢复按钮文本
          this.buttonColor = "#198cff"; // 恢复按钮颜色
          this.buttonCursor = "pointer";
        }
      }, 1000);
    }
  }
};
</script>

<style scoped>
.nav-tab {
  position: fixed !important;
  padding-left: 0.4rem;
  padding-right: 0.4rem;
  background-color: #f9fafb;
  top: 1rem;
  z-index: 998;
  width: 100%;
}

.pin {
  margin: 1.4rem 0rem 0rem 0.1rem;
  font-size: 0.7rem;
  font-weight: 600;
  color: #000;
}

.font {
  font-size: 0.25rem;
  margin: 0.5rem 0rem 0rem 0.2rem;
  color: #a0a0a0;
}

.font1 {
  font-size: 0.25rem;
  margin: 0.5rem 0rem 0.1rem 0rem;
  color: #050505;
}

.md-codebox {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
}

.input-operator {
  background: #198cff;
  width: 1.6rem;
  height: 0.8rem;
  border-radius: 0.1rem;
  color: #fff;
  line-height: 0.8rem;
  text-align: center;
}

.md-codebox-box {
  position: relative;
  -webkit-box-flex: 0;
  -webkit-flex: 0 1 0.8rem;
  flex: 0 1 0.66rem;
  width: 1.66rem;
  height: 0.7rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  color: #01080f;
  font-size: 0.5rem;
  font-weight: 400;
  line-height: 1.2;
  margin-left: 0.09rem;
  margin-right: 0.09rem;
}

.md-codebox {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// src/views/my/pin.vue